import localizationKeys from "src/i18n/localizationKeys";

export interface SettingType {
  type: string;
}

type Option = {
  value: string
  label: string
}

class Options implements SettingType {
  type: string;
  options: Option[];

  constructor(type: string, options: Option[]) {
    this.type = type;
    this.options = options;
  }
}

export const LanguageOptionsSettingType = new Options("LanguageOptions", [
  {
    label: "English",
    value: "en",
  },
  {
    label: "German",
    value: "de",
  },
]);

export const SwitchSettingType: SettingType = { type: "Switch" };

export type SettingSpec<T> = {
  key: string
  labelKey: string
  tooltip?: string
  type: SettingType
  defaultValue: T
}
export type SettingsCategory = {
  labelKey: string
  settings: SettingSpec<unknown>[]
}

export const settingKeys = {
  useDarkMode: "useDarkMode",
  language: "language",
};

export const settingsSpec: SettingsCategory[] = [
  {
    labelKey: localizationKeys.settings.design.title,
    settings: [
      {
        key: settingKeys.useDarkMode,
        labelKey: localizationKeys.settings.design.useDarkMode,
        type: SwitchSettingType,
        defaultValue: false,
      },
    ],
  },
  {
    labelKey: localizationKeys.settings.language.title,
    settings: [
      {
        key: settingKeys.language,
        labelKey: localizationKeys.settings.language.language,
        type: LanguageOptionsSettingType,
        defaultValue: "de",
      },
    ],
  },
];
